function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullScreen = function SvgFullScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.916 1.033H6.443c-.936 0-1.695.683-1.695 1.524v7.62h3.39V4.081h6.778Zm10.168 3.048V1.033h8.473c.936 0 1.695.683 1.695 1.524v7.62h-3.39V4.081Zm0 21.337h6.779v-6.096h3.39v7.62c0 .841-.76 1.524-1.696 1.524h-8.473ZM8.137 19.322v6.096h6.779v3.048H6.443c-.936 0-1.695-.683-1.695-1.524v-7.62z",
    style: {
      strokeWidth: 1.75318
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "10.6667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif"
    },
    x: 6.297,
    y: 39.729
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.297,
    y: 39.729,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "MAX")));
};
export default SvgFullScreen;